import React from 'react';
import Modal from 'react-modal';

Modal.setAppElement('body');

import { Close } from '../../icons';
import CtaButton from '../CtaButton';
import {
  StyledCancelButton,
  StyledCloseButton,
  StyledPanelContent,
  StyledOverlay,
  StyledPanel,
  StyledPanelHeaderBar,
  StyledTitle,
  StyledPanelBottomBar,
} from './ModalChoiceBox.styles';
import { IModalChoiceBoxProps } from './ModalChoiceBox.types';

const ModalChoiceBox = ({
  ariaLabel = 'Close',
  title,
  buttonDiscardText,
  buttonSaveText,
  buttonSaveWidth,
  children,
  isOpen,
  user = 'landlord',
  onClose,
  onDiscard,
  onSave,
}: IModalChoiceBoxProps): JSX.Element => {
  return (
    <Modal
      bodyOpenClassName="prevent-scroll"
      className=" "
      contentElement={(props, children) => (
        <StyledPanel {...props}>{children}</StyledPanel>
      )}
      isOpen={isOpen}
      onRequestClose={onClose}
      overlayClassName=" "
      overlayElement={(props, contentElement) => (
        <StyledOverlay {...props}>{contentElement}</StyledOverlay>
      )}
      shouldCloseOnOverlayClick={true}
    >
      <StyledPanelHeaderBar>
        {title && <StyledTitle>{title}</StyledTitle>}
        <StyledCloseButton aria-label={ariaLabel} onClick={onClose}>
          <Close />
        </StyledCloseButton>
      </StyledPanelHeaderBar>
      <StyledPanelContent>{children}</StyledPanelContent>
      <StyledPanelBottomBar>
        <StyledCancelButton
          aria-disabled={!onDiscard}
          user={user}
          onClick={() => onDiscard && onDiscard()}
        >
          {buttonDiscardText}
        </StyledCancelButton>
        <CtaButton user={user} width={buttonSaveWidth} onClick={onSave}>
          {buttonSaveText}
        </CtaButton>
      </StyledPanelBottomBar>
    </Modal>
  );
};

export default ModalChoiceBox;
